/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DropInEngagementSummary
 */
export interface DropInEngagementSummary {
    /**
     * Impressions on the Drop-In directory landing (sentinel entity)
     * @type {number}
     * @memberof DropInEngagementSummary
     */
    directoryVisits: number;
    /**
     * Filter / search / sort / pagination clicks on the directory
     * @type {number}
     * @memberof DropInEngagementSummary
     */
    filterInteractions: number;
    /**
     * Impressions across all real drops (card impressions + page visits)
     * @type {number}
     * @memberof DropInEngagementSummary
     */
    dropImpressions: number;
    /**
     * Clicks across all real drops (card nav + section + storefront + follow button)
     * @type {number}
     * @memberof DropInEngagementSummary
     */
    dropClicks: number;
    /**
     * 
     * @type {number}
     * @memberof DropInEngagementSummary
     */
    follows: number;
    /**
     * Approximate unique users (nightly HLL snapshot, not time-filtered)
     * @type {number}
     * @memberof DropInEngagementSummary
     */
    uniqueUsers: number;
    /**
     * dropClicks / dropImpressions
     * @type {number}
     * @memberof DropInEngagementSummary
     */
    ctr: number;
}

/**
 * Check if a given object implements the DropInEngagementSummary interface.
 */
export function instanceOfDropInEngagementSummary(value: object): value is DropInEngagementSummary {
    if (!('directoryVisits' in value) || value['directoryVisits'] === undefined) return false;
    if (!('filterInteractions' in value) || value['filterInteractions'] === undefined) return false;
    if (!('dropImpressions' in value) || value['dropImpressions'] === undefined) return false;
    if (!('dropClicks' in value) || value['dropClicks'] === undefined) return false;
    if (!('follows' in value) || value['follows'] === undefined) return false;
    if (!('uniqueUsers' in value) || value['uniqueUsers'] === undefined) return false;
    if (!('ctr' in value) || value['ctr'] === undefined) return false;
    return true;
}

export function DropInEngagementSummaryFromJSON(json: any): DropInEngagementSummary {
    return DropInEngagementSummaryFromJSONTyped(json, false);
}

export function DropInEngagementSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropInEngagementSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'directoryVisits': json['directoryVisits'],
        'filterInteractions': json['filterInteractions'],
        'dropImpressions': json['dropImpressions'],
        'dropClicks': json['dropClicks'],
        'follows': json['follows'],
        'uniqueUsers': json['uniqueUsers'],
        'ctr': json['ctr'],
    };
}

export function DropInEngagementSummaryToJSON(json: any): DropInEngagementSummary {
    return DropInEngagementSummaryToJSONTyped(json, false);
}

export function DropInEngagementSummaryToJSONTyped(value?: DropInEngagementSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'directoryVisits': value['directoryVisits'],
        'filterInteractions': value['filterInteractions'],
        'dropImpressions': value['dropImpressions'],
        'dropClicks': value['dropClicks'],
        'follows': value['follows'],
        'uniqueUsers': value['uniqueUsers'],
        'ctr': value['ctr'],
    };
}

